var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-spacer'),(_vm.mixValidaScopesActions(1))?_c('custom-button',{attrs:{"label":"Nueva","iconText":"mdi-plus","tipo":"agregar"},on:{"click":_vm.nuevo}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }